import appConfig from '../../config/appConfig';
import {REDIRECT_LOADER_NAME} from '../../consts/loader/loaderNames';
import {hideLoader, showLoader} from '../../state/ducks/global';
import {selectConsumerData} from '../../state/selectors/consumer';
import {dispatch, getState} from '../../state/store';
import helpers from '../../utils/helpers';
import stringUtils from '../../utils/stringUtils';
import urlUtils from '../../utils/urlUtils';
import routerService from '../routerService';
import userDeviceService from '../user/userDeviceService';
import iccService from './iccService';

const getSsoLink = async (deeplinkTemplate) => {
    if (process.env.REACT_APP_IS_BUILD_REF !== 'true' && deeplinkTemplate) {
        const scpCloudTopicMarket = appConfig.getScpCloudTopicMarket();
        const {defaultLocaleCode} = selectConsumerData(getState());
        const localization = appConfig.getLocalizationKey() || defaultLocaleCode;

        if (localization && scpCloudTopicMarket) {
            const formattedDeeplink = stringUtils.formatString(
                deeplinkTemplate,
                scpCloudTopicMarket?.toUpperCase(),
                localization?.toUpperCase()
            );

            return await iccService.fetchSSOLink(formattedDeeplink);
        }
    } else {
        return null;
    }
};

const redirectWithSsoLink = async ({deeplinkTemplate, codentify, externalLink, params, beforeRedirectAction}) => {
    dispatch(showLoader(REDIRECT_LOADER_NAME));
    const ssoLink = await getSsoLink(deeplinkTemplate);

    const ssoLinkParams = [{name: 'codentify', value: codentify}];

    if (params) {
        ssoLinkParams.push({...params});
    }

    const isSsoLink = ssoLink && !ssoLink.errorStatus;
    const redirectUrl = isSsoLink ? urlUtils.updateParams(ssoLink, ssoLinkParams) : externalLink;

    const isMobileIOSDevice = userDeviceService.isMobileIOSDevice();
    const isTabletIOSDevice = userDeviceService.isTabletIOSDevice();
    const isAppleTouchDevice = isMobileIOSDevice || isTabletIOSDevice;

    helpers.runFunction(beforeRedirectAction);

    // sso link does not open on first click in new tab on iOS devices
    if (isSsoLink && isAppleTouchDevice) {
        routerService.redirect(redirectUrl);
    } else {
        routerService.blankLinkOpen(redirectUrl);
    }

    dispatch(hideLoader(REDIRECT_LOADER_NAME));
};

export default {
    getSsoLink,
    redirectWithSsoLink,
};
